import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=3e0a3493"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports